import React from "react";

const TextCode = ({ text = "" }) => {
  return <span className="ml-1 font-semibold py-2 px-2.5 bg-gray-100 rounded-md font-['Courier New','monospace']">{text}</span>;
};

export default TextCode;
